module.exports = __webpack_public_path__ + "static/media/logo-quickbook.355b37f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-quickbook.png
// module id = 1306
// module chunks = 17